// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__n2t-S"};